<template>
  <div class="footer">
    <img
      v-if="$i18n.locale === 'bg'"
      class="map-mobile"
      src="../../assets/img/map.png"
      alt="map"
    />
    <img
      v-else
      class="map-mobile"
      src="../../assets/img/map_en.png"
      alt="map"
    />
    <div class="footer-top">
      <div class="form-wrapper">
        <h3 class="footer-top-title text-color">
          {{ $t("footer-nav-make-inquiry") }}
        </h3>
        <form @submit.prevent="submit()" id="footerInquiryForm">
          <div class="row">
            <div class="input-wrapper">
              <input
                type="text"
                v-model="inquiry.name"
                :placeholder="$t('footer-nav-form-1')"
              />
            </div>
            <div class="input-wrapper">
              <input
                type="text"
                v-model="inquiry.phone"
                :placeholder="$t('footer-nav-form-2')"
              />
            </div>
            <div class="input-wrapper">
              <input
                type="email"
                v-model="inquiry.email"
                placeholder="e-mail"
              />
            </div>
          </div>
          <div class="row">
            <div class="select-wrapper">
              <select v-model="inquiry.category">
                <option value selected disabled>
                  {{ $t("footer-nav-form-5") }}
                </option>
                <option :value="$t('footer-nav-2-1')">
                  {{ $t("footer-nav-2-1") }}
                </option>
                <option :value="$t('footer-nav-2-2')">
                  {{ $t("footer-nav-2-2") }}
                </option>
                <option :value="$t('footer-nav-2-3')">
                  {{ $t("footer-nav-2-3") }}
                </option>
                <option :value="$t('footer-nav-2-4')">
                  {{ $t("footer-nav-2-4") }}
                </option>
                <option :value="$t('footer-nav-2-5')">
                  {{ $t("footer-nav-2-5") }}
                </option>
                <option :value="$t('footer-nav-2-6')">
                  {{ $t("footer-nav-2-6") }}
                </option>
                <option :value="$t('footer-nav-2-7')">
                  {{ $t("footer-nav-2-7") }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="textarea-wrapper">
              <textarea
                cols="30"
                rows="10"
                v-model="inquiry.message"
                :placeholder="$t('footer-nav-form-3')"
              ></textarea>
            </div>
          </div>
          <div class="row form-submit-row">
            <p>
              {{ $t("footer-nav-form-6") }}
              <router-link to="/sustainability?page=gdpr">{{
                $t("footer-nav-form-7")
              }}</router-link>
            </p>
            <div class="captcha-and-submit">
              <div class="captcha-wrapper" v-if="captcha">
                <p v-if="captcha.numOne && captcha.numTwo">
                  {{ captcha.numOne }} + {{ captcha.numTwo }} =
                </p>
                <div class="input-wrapper">
                  <input type="text" v-model="inquiry.captchaSum" />
                </div>
              </div>
              <a class="link" @click.prevent="submit()">
                <span class="text-color">{{ $t("send") }}</span>
              </a>
            </div>
          </div>
        </form>
      </div>
      <Map class="bg-map" />
    </div>

    <!-- <div class="signal-wrapper">
      <a href="/signal" target="_blank" class="signal-button" v-if="$i18n.locale === 'bg'">
        <img src="../../assets/img/signal.svg" alt="signal img">
        <span>{{ $t('signal.button') }}</span>
      </a>
    </div> -->

    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <div class="kcm-logo-and-text">
          <img class="footer-logo" src="../../assets/img/logo.svg" alt="KCM" />
          <p>&copy; {{ $t("footer-nav-1-title") }}, {{ date.getFullYear() }}</p>
          <br />
        </div>
        <p class="cdots">
          {{ $t("footer-nav-cdots-1") }}
          <a href="https://cdots.bg/" target="_blank">cDots Corporation</a>,
          <br />
          {{ date.getFullYear() }} {{ $t("footer-nav-cdots-2") }}
        </p>
      </div>
      <div class="footer-nav">
        <ul>
          <p class="footer-nav-title">{{ $t("footer-nav-1-title") }}</p>
          <li></li>
          <li>
            <router-link to="/kcm-group">{{
              $t("footer-nav-1-0")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=1">{{
              $t("footer-nav-1-1")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=2">{{
              $t("footer-nav-1-2")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=3">{{
              $t("footer-nav-1-3")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=4">{{
              $t("footer-nav-1-4")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=5">{{
              $t("footer-nav-1-5")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=6">{{
              $t("footer-nav-1-6")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=7">{{
              $t("footer-nav-1-7")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=8">{{
              $t("footer-nav-1-8")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=9">{{
              $t("footer-nav-1-9")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=10">{{
              $t("footer-nav-1-10")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=11">{{
              $t("footer-nav-1-11")
            }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group?page=companies&c=12">{{
              $t("footer-nav-1-12")
            }}</router-link>
          </li>
        </ul>
        <ul>
          <p class="footer-nav-title">{{ $t("footer-nav-2-title") }}</p>
          <li>
            <router-link to="/products">{{ $t("footer-nav-2-1") }}</router-link>
          </li>
          <li>
            <router-link to="/products?page=zn">{{
              $t("footer-nav-2-2")
            }}</router-link>
          </li>
          <li>
            <router-link to="/products?page=pb">{{
              $t("footer-nav-2-3")
            }}</router-link>
          </li>
          <li>
            <router-link to="/products?page=au">{{
              $t("footer-nav-2-4")
            }}</router-link>
          </li>
          <li>
            <router-link to="/products?page=ag">{{
              $t("footer-nav-2-5")
            }}</router-link>
          </li>
          <li>
            <router-link to="/products?page=ch">{{
              $t("footer-nav-2-6")
            }}</router-link>
          </li>
        </ul>
        <ul>
          <p class="footer-nav-title">{{ $t("footer-nav-3-title") }}</p>
          <li>
            <router-link to="/about">{{ $t("footer-nav-3-1") }}</router-link>
          </li>
          <li>
            <router-link to="/about?page=history">{{
              $t("footer-nav-3-2")
            }}</router-link>
          </li>
          <li>
            <router-link to="/about?page=mission">{{
              $t("footer-nav-3-3")
            }}</router-link>
          </li>
        </ul>
        <ul>
          <p class="footer-nav-title">{{ $t("footer-nav-4-title") }}</p>
          <li>
            <router-link to="/about">{{ $t("nav1") }}</router-link>
          </li>
          <li>
            <router-link to="/kcm-group">{{ $t("nav2") }}</router-link>
          </li>
          <li>
            <router-link to="/products">{{ $t("nav3") }}</router-link>
          </li>
          <li>
            <router-link to="/sustainability">{{ $t("nav4") }}</router-link>
          </li>
          <li>
            <router-link to="/careers">{{ $t("nav5") }}</router-link>
          </li>
          <li>
            <router-link to="/news">{{ $t("nav6") }}</router-link>
          </li>
          <li>
            <router-link to="/contacts">{{ $t("nav7") }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <img class="down-right-img" src="../../assets/img/footer_.png" />
  </div>
</template>

<script>
import inquiry from "../mixins/inquiry.js";
import captcha from "../mixins/captcha.js";
import Map from "./Map";
export default {
  components: {
    Map,
  },
  mixins: [inquiry, captcha],
  watch: {
    $route() {
      this.updateCategoryWhenProducts();
    },
    "$i18n.locale"() {
      this.updateCategoryWhenProducts();
    },
  },
  data() {
    return {
      date: new Date(),
      captcha: null,
      inquiry: {
        name: "",
        phone: "",
        email: "",
        category: "",
        message: "",
        url: "",
        captchaSum: "",
      },
    };
  },
  methods: {
    updateCategoryWhenProducts() {
      const to = this.$route;
      if (to.name === "products") {
        this.inquiry.category = this.$t("footer-nav-2-1");
        if (to.query.page === "zn") {
          this.inquiry.category = this.$t("footer-nav-2-2");
        }
        if (to.query.page === "pb") {
          this.inquiry.category = this.$t("footer-nav-2-3");
        }
        if (to.query.page === "au") {
          this.inquiry.category = this.$t("footer-nav-2-4");
        }
        if (to.query.page === "ag") {
          this.inquiry.category = this.$t("footer-nav-2-5");
        }
        if (to.query.page === "ch") {
          this.inquiry.category = this.$t("footer-nav-2-6");
        }
        this.inquiry.url = this.$t("inquiry-9");
      } else if (to.name === "lifeRecad") {
        this.inquiry.category = this.$t("footer-nav-2-7");
      } else {
        this.inquiry.url = "";
        this.inquiry.category = "";
      }
    },
    submit() {
      this.sendMail(this.inquiry, this.captcha)
        .then(() => {
          this.inquiry = {
            name: "",
            phone: "",
            email: "",
            category: "",
            message: "",
            url: "",
            captchaSum: "",
          };
          this.captcha = this.getCaptcha();
          if (this.$route.name === "products") {
            this.inquiry.url = this.$t("inquiry-9");
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.captcha = this.getCaptcha();
    this.updateCategoryWhenProducts();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  @extend %flex-center;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#dbdcdc+0,f1f1f1+100&0.65+0,1+0,1+100 */
  background: -moz-linear-gradient(
    top,
    rgba(219, 220, 220, 1) 0%,
    rgba(241, 241, 241, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(219, 220, 220, 1) 0%,
    rgba(241, 241, 241, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(219, 220, 220, 1) 0%,
    rgba(241, 241, 241, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dbdcdc', endColorstr='#f1f1f1',GradientType=0 ); /* IE6-9 */
  flex-direction: column;
  // margin-top: $sidesPadding / 2;
  padding-bottom: $sidesPadding / 2;
  position: relative;
  width: 100%;
  .down-right-img {
    bottom: 0;
    position: absolute;
    right: 0;
    z-index: 1;
  }
  .footer-top {
    @extend %flex-center;
    justify-content: space-between;
    padding: $sidesPadding;
    padding-bottom: $sidesPadding / 2;
    padding-top: $sidesPadding / 2;
    position: relative;
    width: 100%;
    .form-wrapper {
      /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+80,ffffff+100&0.55+80,0+100 */
      background: -moz-linear-gradient(
        left,
        rgba(255, 255, 255, 0.55) 80%,
        rgba(255, 255, 255, 0) 100%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        rgba(255, 255, 255, 0.55) 80%,
        rgba(255, 255, 255, 0) 100%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.55) 80%,
        rgba(255, 255, 255, 0) 100%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8cffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
      width: 100%;
      .footer-top-title {
        position: absolute;
        top: $sidesPadding / 4;
      }
      form {
        border-left: 11px solid $bgColor1;
        padding: 15px 25px;
        width: 45%;
        .row {
          margin-bottom: 20px;
          .input-wrapper {
            margin-right: 20px;
          }
          .input-wrapper:last-child {
            margin: 0;
          }
        }
        textarea {
          resize: none;
          width: 100%;
        }
        .form-submit-row {
          align-items: center;
          justify-content: space-between;
          p {
            font-size: 10px;
            line-height: 12px;
            width: 45%;
            a {
              text-decoration: underline;
            }
            a:hover {
              opacity: 0.8;
            }
          }
          .captcha-and-submit {
            display: flex;
            .captcha-wrapper {
              p {
                margin: 0;
              }
            }
          }
          .link::before {
            background-color: $accentColor;
          }
        }
      }
    }
    .bg-map {
      height: 94%;
      max-width: 50%;
      position: absolute;
      right: $sidesPadding;
      top: 3%;
      overflow: hidden;
    }
  }
  .signal-wrapper {
    display: flex;
    padding: 0 0 40px $sidesPadding;
    width: 100%;

    .signal-button {
      align-items: center;
      border-left: 11px solid #0a1f54;
      background: #f7f7f7;
      color: #164194;
      display: flex;
      font-size: 10px;
      gap: 20px;
      height: 77px;
      padding: 15px 20px 15px 15px;
      width: 400px;
      @include transition(all 0.3s);

      &:hover {
        background: #c5d1e7;
      }
      img {
        width: 40px;
      }
    }
  }
  .footer-bottom {
    @extend %flex-center;
    align-items: stretch;
    justify-content: space-between;
    padding: 0 $sidesPadding;
    width: 100%;
    .footer-bottom-left {
      @extend %flex-center;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-between;
      margin-right: $sidesPadding;
      min-width: 25%;
      .kcm-logo-and-text {
        .footer-logo {
          height: auto;
          margin-bottom: 35px;
          width: 250px;
        }
        p {
          font-size: 14px;
        }
      }
      .cdots {
        font-size: 10px;
        opacity: 0.7;
        a:hover {
          text-decoration: underline;
        }
      }
    }
    .footer-nav {
      align-items: flex-start;
      display: flex;
      justify-content: space-between;
      width: 100%;
      ul {
        width: 20%;
        .footer-nav-title {
          color: $bgColor1;
          font-size: 14px;
          font-weight: 700;
          padding-bottom: 5px;
          margin-bottom: 20px;
          position: relative;
        }
        .footer-nav-title::before {
          background-color: $bgColor1;
          bottom: 0;
          content: "";
          height: 2px;
          left: 0;
          position: absolute;
          width: 100%;
        }
        li {
          a {
            display: inline-block;
            font-size: 12px;
            padding: 8px 0;
          }
          a:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .map-mobile {
    display: none;
  }
}
@media screen and (max-width: 1600px) {
  .footer {
    // margin-top: $sidesPadding1600 / 2;
    padding-bottom: $sidesPadding1600 / 2;
    .footer-top {
      padding: $sidesPadding1600;
      padding-bottom: $sidesPadding1600 / 2;
      padding-top: $sidesPadding1600 / 2;
      .form-wrapper {
        .footer-top-title {
          top: $sidesPadding1600 / 4;
        }
      }
      .bg-map {
        right: $sidesPadding1600;
      }
    }
    .signal-wrapper {
      padding: 0 0 40px $sidesPadding1600;
    }
    .footer-bottom {
      padding: 0 $sidesPadding1600;
      .footer-bottom-left {
        margin-right: $sidesPadding1600;
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .footer {
    .footer-top {
      .form-wrapper form {
        .form-submit-row {
          p {
            line-height: 16px;
          }
        }
      }
      .bg-map {
        height: 90%;
        max-width: 40%;
        top: 5%;
      }
    }
    .footer-bottom {
      .footer-bottom-left {
        margin-right: 50px;
        min-width: 23%;
        .kcm-logo-and-text {
          .footer-logo {
            margin-bottom: 20px;
            width: 200px;
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1376px) {
  .footer {
    .footer-top {
      .form-wrapper .footer-top-title {
        font-size: 11px;
      }
      .form-wrapper form {
        width: 50%;
        .form-submit-row {
          p {
            font-size: 9px;
            line-height: 14px;
          }
        }
      }
      .bg-map {
        height: 90%;
        max-width: 40%;
        top: 5%;
      }
    }
    .footer-bottom {
      .footer-bottom-left {
        margin-right: 50px;
        min-width: 23%;
        .kcm-logo-and-text {
          .footer-logo {
            margin-bottom: 20px;
            width: 180px;
          }
          p {
            font-size: 11px;
          }
        }
      }
      .footer-nav {
        ul {
          .footer-nav-title {
            font-size: 11px;
          }
          li {
            a {
              font-size: 10px;
              padding: 6px 0;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .footer {
    padding-bottom: $sidesPadding1280 / 2;
    .footer-top {
      padding: $sidesPadding1280;
      padding-bottom: $sidesPadding1280;
      padding-top: $sidesPadding1280;
      .form-wrapper {
        .footer-top-title {
          top: $sidesPadding1280 / 2;
        }
      }
      .bg-map {
        right: $sidesPadding1280;
      }
    }
    .signal-wrapper {
      padding-left: $sidesPadding1280;
    }
    .footer-bottom {
      padding: 0 $sidesPadding1280;
      .footer-bottom-left {
        margin-right: $sidesPadding1280;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .footer {
    padding-bottom: 0;
    background-color: #dbdcdc;
    .map-mobile {
      display: block;
      height: auto;
      width: 100%;
    }
    .footer-top {
      padding: 0;
      .form-wrapper {
        background: transparent;
        .footer-top-title {
          padding: 20px;
          position: static;
          text-align: center;
        }
        form {
          background-color: rgba(255, 255, 255, 0.55);
          border-right: 11px solid transparent;
          width: 100%;
        }
      }
      .bg-map {
        display: none;
      }
    }
    .signal-wrapper {
      justify-content: center;
      padding: $sidesPadding1280 0;
    }
    .footer-bottom {
      background-color: #dbdcdc;
      justify-content: center;
      padding: $sidesPadding1280;
      .footer-bottom-left {
        margin-right: 0;
        align-items: center;
        .kcm-logo-and-text {
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .cdots {
          text-align: center;
        }
      }
      .footer-nav {
        display: none;
      }
    }
    .down-right-img {
      width: 25%;
    }
  }
}

@media screen and (max-width: 600px) {
  .footer {
    .footer-top {
      .form-wrapper {
        form {
          .row {
            flex-direction: column;
          }
          .form-submit-row {
            > p {
              margin-bottom: 15px;
              text-align: center;
              width: 100%;
            }
            flex-direction: column;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .footer {
    .footer-top {
      .form-wrapper {
        form {
          background-color: rgba(255, 255, 255, 0.55);
          border-right: 11px solid transparent;
          width: 100%;
          .form-submit-row {
            flex-direction: column;
            margin: 10px;
            p {
              width: 100%;
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
